import { useEffect, useState } from 'react';
import { Box, Modal, Paper, Grid, Typography, IconButton } from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { clientAxios8080 } from '../../../../configs/axios';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  height: '60%',
  width: '60%',
};
const columnStyle = {
  margin: '0 1rem',
};

const itemStyle = {
  marginBottom: '1rem',
};

async function getReportTicketMonthMultipleDetai() {
  try {
    const response = await clientAxios8080.get('/ms-tickets/serviceLevels/getReportTicketMonthMultipleDetai');
    const responseDataListTicketsByDaysInMonth = response.data.data.listTicketsByDaysInMonth;

    // Filtrar elementos con "numeroTickets" igual a 0
    const filteredData = responseDataListTicketsByDaysInMonth.filter(item => item.numeroTickets !== 0);

    // Agregar un id único a cada fila
    const formattedChartData = filteredData.map((item, index) => ({
      ...item,
      id: index.toString(), // Puedes ajustar esto según tus necesidades
    }));

    return formattedChartData;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}


async function getDetailTicketsByMonth(date) {
  try {
    const response = await clientAxios8080.get('/ms-tickets/serviceLevels/getDetailTicketsByMonth');
    const responseData = response.data.data;
    console.log('modal tickets por mes data', responseData);

    // Filtrar los datos según la fecha
    const filteredData = responseData.filter((item) => item.dia === date);

    // Seleccionar solo las columnas necesarias
    const selectedData = filteredData.map((item) => ({
      dia: item.dia,
      ticket_id: item.ticket_id,
      casoid: item.casoid,
      usuarioreporta: item.usuarioreporta,
      usuariocargo: item.usuariocargo,
      oficina: item.oficina,
      telusuario: item.telusuario,
      refenlace: item.refenlace,
      numreportesoc: item.numreportesoc,
      numreportebestel: item.numreportebestel,
      numreportecliente: item.numreportecliente,
      responsable: item.responsable,
      ingasignado: item.ingasignado,
      serial: item.serial,
      detalle: item.detalle,
      actividad: item.actividad,
      fc_fechacreacion: item.fc_fechacreacion,
      status: item.status,
      prioridad: item.prioridad,
      severidad: item.severidad,
      descripcion: item.descripcion,
      boafectacion: item.boafectacion,
      boatribuible: item.boatribuible,
      ticketstatus_id: item.ticketstatus_id,
      tipofalla_id: item.tipofalla_id,
      tiporequerimiento_id: item.tiporequerimiento_id,
      tickettipo_id: item.tickettipo_id,
      criticidadticket_id: item.criticidadticket_id,
      sitio_id: item.sitio_id,
      fc_inicioticket: item.fc_inicioticket,
      fc_finticket: item.fc_finticket,
      duracion: item.duracion,
      tiempo_afectacion_minutos: item.tiempo_afectacion_minutos,
      tiempo_afectacion_atribuible: item.tiempo_afectacion_atribuible,
      bst2_tiempo_afectacion_concil: item.bst2_tiempo_afectacion_concil,
      estatus: item.estatus,
      dstipofalla: item.dstipofalla,
      dsrequerimiento: item.dsrequerimiento,
      dstickettipo: item.dstickettipo,
      dscriticidad: item.dscriticidad,
    }));

    return selectedData;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

const TicketsChart = () => {
  const [chartData, setChartData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedDetailRowData, setSelectedDetailRowData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataResponse = await getReportTicketMonthMultipleDetai();
        const data = await getDetailTicketsByMonth(selectedRowData.fecha);

        // Invertir el orden de las fechas
        const reversedData = dataResponse.slice().reverse();
        setChartData(reversedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [selectedRowData.fecha]);

  const openModal = async (data) => {
    const selectedDate = data.payload.dia;

    try {
      const dataForDate = await getDetailTicketsByMonth(selectedDate);
      setSelectedRowData(dataForDate);
      setModalOpen(true);
    } catch (error) {
      console.error('Error fetching data for date:', error);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // Function to open detail modal
  const openDetailModal = (rowData) => {
    setSelectedDetailRowData(rowData);
    setDetailModalOpen(true);
  };

  // Function to close detail modal
  const closeDetailModal = () => {
    setDetailModalOpen(false);
  };

  const columns = [
    { field: 'numreportesoc', headerName: 'Número de Reporte SOC', width: 200 },
    { field: 'numreportebestel', headerName: 'Número de Reporte Bestel', width: 200 },
    { field: 'responsable', headerName: 'Responsable', width: 150 },
    { field: 'fc_inicioticket', headerName: 'Inicio del Ticket', width: 200 },
    { field: 'estatus', headerName: 'Estatus', width: 120 },
    { field: 'dstipofalla', headerName: 'Tipo de Falla', width: 150 },
    { field: 'dsrequerimiento', headerName: 'Requerimiento', width: 150 },
    { field: 'dstickettipo', headerName: 'Tipo de Ticket', width: 150 },
    { field: 'dscriticidad', headerName: 'Criticidad', width: 150 },
  ];

  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart width={500} height={300} data={chartData}>
          <XAxis
            tick={{ fontSize: 12, fill: '#ffffff' }}
            dataKey="dia"
          />
          <YAxis
            tick={{ fontSize: 12, fill: '#ffffff' }}
          />
          <Tooltip />
          <Bar
            dataKey="numeroTickets"
            name="Número de tickets:"
            fill="#28b463"
            stackId="stack"
            minPointSize={10}
            onClick={(data) => openModal({ payload: data.payload })}
          />
        </BarChart>
      </ResponsiveContainer>

      <Modal open={modalOpen} onClose={closeModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box display="flex" justifyContent="center" alignItems="center" sx={modalStyle}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              top: '5px',
              right: '15px',
            }}
          >
            <CloseIcon />
          </IconButton>
          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              columns={columns}
              rows={selectedRowData}
              rowsPerPageOptions={[10, 50, 100]}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              getRowId={(row) => row.numreportesoc}
              onRowClick={(params) => openDetailModal(params.row)}
            />
          </div>
        </Box>
      </Modal>
      <Modal
        open={detailModalOpen}
        onClose={closeDetailModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box display="flex" justifyContent="center" alignItems="center" sx={modalStyle}>
          <Paper sx={{ p: 2, position: 'relative' }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={closeDetailModal}
              sx={{
                position: 'absolute',
                top: '5px',
                right: '15px',
              }}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6">Detalle del ticket</Typography>
            <Grid container spacing={2}>
              <Grid item xs={5} style={columnStyle}>
                <div style={itemStyle}>
                  <strong>Ticket Id:</strong>
                  {selectedDetailRowData.ticket_id}
                </div>
                <div style={itemStyle}>
                  <strong>Caso Id:</strong>
                  {selectedDetailRowData.casoid}
                </div>
                <div style={itemStyle}>
                  <strong>Usuario que reporta:</strong>
                  {selectedDetailRowData.usuarioreporta}
                </div>
                <div style={itemStyle}>
                  <strong>Usuario cargo:</strong>
                  {selectedDetailRowData.usuariocargo}
                </div>
                <div style={itemStyle}>
                  <strong>Oficina:</strong>
                  {selectedDetailRowData.oficina}
                </div>
                <div style={itemStyle}>
                  <strong>Teléfono usuario:</strong>
                  {selectedDetailRowData.telusuario}
                </div>
                <div style={itemStyle}>
                  <strong>Referencia enlace:</strong>
                  {selectedDetailRowData.refenlace}
                </div>
                <div style={itemStyle}>
                  <strong>Número reporte SOC:</strong>
                  {selectedDetailRowData.numreportesoc}
                </div>
                <div style={itemStyle}>
                  <strong>Número reporte Bestel:</strong>
                  {selectedDetailRowData.numreportebestel}
                </div>
                <div style={itemStyle}>
                  <strong>Número reporte cliente:</strong>
                  {selectedDetailRowData.numreportecliente}
                </div>
                <div style={itemStyle}>
                  <strong>Responsable:</strong>
                  {selectedDetailRowData.responsable}
                </div>
                <div style={itemStyle}>
                  <strong>Ingeniero asignado:</strong>
                  {selectedDetailRowData.ingasignado}
                </div>
                <div style={itemStyle}>
                  <strong>Serial:</strong>
                  {selectedDetailRowData.serial}
                </div>
                <div style={itemStyle}>
                  <strong>Actividad:</strong>
                  {selectedDetailRowData.actividad}
                </div>
                <div style={itemStyle}>
                  <strong>Día:</strong>
                  {selectedDetailRowData.dia}
                </div>
                <div style={itemStyle}>
                  <strong>Prioridad:</strong>
                  {selectedDetailRowData.prioridad}
                </div>
                <div style={itemStyle}>
                  <strong>Severidad:</strong>
                  {selectedDetailRowData.severidad}
                </div>
                <div style={itemStyle}>
                  <strong>Descripción:</strong>
                  {selectedDetailRowData.descripcion}
                </div>
                <div style={itemStyle}>
                  <strong>Afectación:</strong>
                  {selectedDetailRowData.boafectacion ? 'Sí' : 'No'}
                </div>
                <div style={itemStyle}>
                  <strong>Atribuible:</strong>
                  {selectedDetailRowData.boatribuible ? 'Sí' : 'No'}
                </div>
              </Grid>
              <Grid item xs={5} style={columnStyle}>
                <div style={itemStyle}>
                  <strong>Detalle:</strong>
                  {selectedDetailRowData.detalle}
                </div>
                <div style={itemStyle}>
                  <strong>Fecha de Inicio del Ticket:</strong>
                  {selectedDetailRowData.fc_inicioticket}
                </div>
                <div style={itemStyle}>
                  <strong>Fecha de Fin del Ticket:</strong>
                  {selectedDetailRowData.fc_finticket}
                </div>
                <div style={itemStyle}>
                  <strong>Duración:</strong>
                  {selectedDetailRowData.duracion}
                </div>
                <div style={itemStyle}>
                  <strong>Tiempo de Afectación (minutos):</strong>
                  {selectedDetailRowData.tiempo_afectacion_minutos}
                </div>
                <div style={itemStyle}>
                  <strong>Tiempo Atribuible de Afectación:</strong>
                  {selectedDetailRowData.tiempo_afectacion_atribuible}
                </div>
                <div style={itemStyle}>
                  <strong>Estatus:</strong>
                  {selectedDetailRowData.estatus}
                </div>
                <div style={itemStyle}>
                  <strong>Tipo de Falla:</strong>
                  {selectedDetailRowData.dstipofalla}
                </div>
                <div style={itemStyle}>
                  <strong>Requerimiento:</strong>
                  {selectedDetailRowData.dsrequerimiento}
                </div>
                <div style={itemStyle}>
                  <strong>Tipo de Ticket:</strong>
                  {selectedDetailRowData.dstickettipo}
                </div>
                <div style={itemStyle}>
                  <strong>Criticidad:</strong>
                  {selectedDetailRowData.dscriticidad}
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default TicketsChart;
